import React from 'react';
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, Easing } from 'remotion';
import { CroppedImg } from '../elements/CroppedImg';

const testData = {
    image_w: 1437,
    url: "https://img.werkzeugh.at/unsafe/fit-in/2000x2000/uploads/original/ck/031p/U8dXMkUx5uL4OHiMH4.png",
    image_h: 830,
    crop_end: {
        height: 1,
        width: 0.3248956158663883,
        x: 0.6751043841336116,
        y: 0
    },
    crop_start: {
        height: 1,
        width: 0.3248956158663883,
        x: 0,
        y: 0
    },
    enabled: true,
    image_id: "019b019f-574c-712f-a856-57bbc7b9d7aa"
};

export const TestCroppedImage: React.FC<{
    progress?: number;
}> = ({ progress: progressProp }) => {
    const frame = useCurrentFrame();
    const { durationInFrames } = useVideoConfig();

    // Use linear easing for testing, similar to ImageCarousel logic
    // If progressProp is provided (e.g. from URL), use it. Otherwise calculate from frame.
    const progress = progressProp ?? interpolate(frame, [0, durationInFrames], [0, 1], {
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp',
        easing: Easing.linear,
    });

    return (
        <AbsoluteFill style={{ backgroundColor: 'black' }}>
            <CroppedImg
                src={testData.url}
                cropStart={testData.crop_start}
                cropEnd={testData.crop_end}
                progress={progress}
                imageWidth={testData.image_w}
                imageHeight={testData.image_h}
            />
        </AbsoluteFill>
    );
};

;
    var _remotion_globalVariableA, _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
